import { useLog } from '@/features/shared/Hooks';
import { getGenetecPostMessage } from '@/utils/helpers';
import { useCallback } from 'react';
import { usePostMessageListener } from '../usePostMessageListener';

export enum PowerAppsPostMessageEvents {
  LOADED = 'loaded',
  DATALAYER = 'datalayer',
  TRIGGER = 'trigger',
  REFRESH = 'refresh',
  UPDATE_PARENT_URL = 'updateParentUrl',
}

interface PowerAppPostMessagePayload {
  event: string;
  data: any;
}

const powerappsPostMessage = getGenetecPostMessage({ source: 'genetec', type: 'connection' });

// Hooks used to listen power apps event from the iframe
export const usePowerAppConnectMessageListener = (
  onMessageReceived: (payload: any) => void,
  event: PowerAppsPostMessageEvents,
) => {
  const Log = useLog({ context: 'usePowerAppConnectMessageListener' });

  const handlePowerAppsMessage = useCallback(
    (props: any) => {
      const powerappsData: PowerAppPostMessagePayload | undefined = powerappsPostMessage(props);
      if (!powerappsData?.event) return;
      Log('PowerAppsEvent captured: ', powerappsData);
      if (powerappsData.event === event) onMessageReceived(powerappsData.data);
    },
    [Log, event, onMessageReceived],
  );

  usePostMessageListener(handlePowerAppsMessage);
};
